// Mirrors the backend `PolicyConstants.cs` (backoffice-service). Keep in sync —
// these strings must match the `.RequireAuthorization(...)` policies on the API.
export const POLICY = {
  ALL: '*',
  USERS_GET: 'auth.read',
  USERS_CREATE_UPDATE: 'auth.read-write',
  PACKAGES_GET: 'packages.read',
  PACKAGES_CREATE_UPDATE: 'packages.read-write',
  LOADER_GET: 'loader.read',
  LOADER_CREATE_UPDATE: 'loader.read-write',
  CLIENT_CONF_GET: 'client-configuration.read',
  CLIENT_CONF_CREATE_UPDATE: 'client-configuration.read-write',
  DICTIONARIES_GET: 'dictionaries.read',
  DICTIONARIES_CREATE_UPDATE: 'dictionaries.read-write',
  ENGINES_GET: 'engines.read',
  ENGINES_CREATE_UPDATE: 'engines.read-write',
  EXTERNAL_GET: 'external.read',
  GAME_CONF_GET: 'game-configuration.read',
  GAME_CONF_CREATE_UPDATE: 'game-configuration.read-write',
  GAME_CONF_GET_EXT: 'external-game.read',
  GAME_CONF_CREATE_UPDATE_EXT: 'external-game.read-write',
  GAME_OPERATORS_GET: 'game-operators.read',
  GAME_OPERATORS_CREATE_UPDATE: 'game-operators.read-write',
  LIMIT_CONF_GET: 'limit-configuration.read',
  LIMIT_CONF_CREATE_UPDATE: 'limit-configuration.read-write',
  JACKPOT_GET: 'jackpot.read',
  JACKPOT_CREATE_UPDATE: 'jackpot.read-write',
  JACKPOT_GROUP_GET: 'jackpot-group.read',
  JACKPOT_GROUP_CREATE_UPDATE: 'jackpot-group.read-write',
  LIQUIDITY_POOL_GET: 'liquidity-pool.read',
  LIQUIDITY_POOL_CREATE_UPDATE: 'liquidity-pool.read-write',
  STUCK_GAME_SESSION_GET: 'stuck-game-session.read',
  STUCK_GAME_SESSION_CREATE_UPDATE: 'stuck-game-session.read-write',
  ROLE_GET: 'role.read',
  ROLE_CREATE_UPDATE: 'role.read-write',
  POLICY_GET: 'policy.read-write', // backend quirk: PolicyRead === 'policy.read-write'
  GAME_CERT_INSERT: 'game-cert.insert',
  GAME_CERT_UPDATE: 'game-cert.update',
  GAME_STATUS_GO_LIVE: 'game-status.go-live',
  OPERATOR_GET: 'operator.read',
  OPERATOR_CREATE_UPDATE: 'operator.read-write',
  OPERATOR_ADMIN: 'operator-admin',
  HISTORY_GET: 'history.read',
  RTP_VERIFICATION_GET: 'rtp-verification.read',
  RTP_VERIFICATION_CREATE_UPDATE: 'rtp-verification.read-write',
  GAME_ENGINE_LOAD_TEST_GET: 'game-engine-load-test.read',
  GAME_ENGINE_LOAD_TEST_CREATE_UPDATE: 'game-engine-load-test.read-write',
  LOAD_TESTS_THRESHOLDS_CREATE_UPDATE: 'update-load-tests-threasholds.read-write',
  GAME_ENGINE_VULNERABILITY_TEST_GET: 'game-engine-vulnerability-test.read',
  GAME_ENGINE_VULNERABILITY_TEST_CREATE_UPDATE: 'game-engine-vulnerability-test.read-write',
  GAME_ENGINE_VULNERABILITY_TEST_RUN: 'game-engine-vulnerability-test.run',
  GAME_BONUS_GET: 'game-bonus.read',
  GAME_BONUS_CREATE_UPDATE: 'game-bonus.read-write',
  SELECT_PAGE_GET: 'select-page.read',
  SELECT_PAGE_CREATE_UPDATE: 'select-page.read-write',
  GAME_SIMULATION_GET: 'game-simulation.read',
  GAME_SIMULATION_CREATE_UPDATE: 'game-simulation.read-write',
  PROVIDER_INTEGRATION_CALLBACK_CREATE_UPDATE: 'provider-integration-callback.read-write',
  AUDIT_GET: 'audit.read',
  GAME_EVENT_LOGGER_GET: 'game-event-logger.read',
  INCIDENT_GET: 'incident.read',
  INCIDENT_CREATE_UPDATE: 'incident.read-write',
  CLIENT_EVENTS_GET: 'client-events.read',
  CLIENT_EVENTS_CREATE_UPDATE: 'client-events.read-write',
};

export const PACKAGE_TYPE = {
  CLIENT: 'Client',
  GAME: 'Game',
  PAY_TABLE: 'PayTable',
};

// {
//   "*": [
//   "Everything"
// ],
//   "auth.read": [
//   "Getting all users"
// ],
//   "auth.read-write": [
//   "Getting all users",
//   "Registering new users"
// ],
//   "binaries.read": [
//   "Getting all binaries"
// ],
//   "binaries.read-write": [
//   "Getting all binaries",
//   "Updating existing binaries",
//   "Addind new binaries"
// ],
//   "client-configuration.read": [
//   "Getting all client configurations"
// ],
//   "client-configuration.read-write": [
//   "Getting all client configurations",
//   "Updating existing client configurations",
//   "Adding new client configurations"
// ],
//   "currencies.read": [
//   "Getting all currencies"
// ],
//   "engines.read": [
//   "Getting all engines"
// ],
//   "external.read": [
//   "Getting all external client configs",
//   "Getting all external game configs"
// ],
//   "game-configuration.read": [
//   "Getting all game configurations"
// ],
//   "game-configuration.read-write": [
//   "Getting all game configurations",
//   "Adding new game configuration",
//   "Updating existing game configurations",
//   "Toggling game config"
// ],
//   "game-operators.read": [
//   "Getting all operators",
//   "Getting all game operator configs"
// ],
//   "game-operators.read-write": [
//   "Getting all operators",
//   "Getting all game operator configs",
//   "Creating game operator config",
//   "Toggling game operator config"
// ],
//   "limit-configuration.read": [
//   "Getting all operator limits"
// ],
//   "limit-configuration.read-write": [
//   "Getting all operator limits",
//   "Adding new operator limit",
//   "Updating existing operator limit"
// ]
// }
